export default "__VITE_ASSET__BLoWucup__"